var map = {
	"./GHS01.gif": "./src/assets/images/GHS01.gif",
	"./GHS02.gif": "./src/assets/images/GHS02.gif",
	"./GHS03.gif": "./src/assets/images/GHS03.gif",
	"./GHS04.gif": "./src/assets/images/GHS04.gif",
	"./GHS05.gif": "./src/assets/images/GHS05.gif",
	"./GHS06.gif": "./src/assets/images/GHS06.gif",
	"./GHS07.gif": "./src/assets/images/GHS07.gif",
	"./GHS08.gif": "./src/assets/images/GHS08.gif",
	"./GHS09.gif": "./src/assets/images/GHS09.gif",
	"./SYM01.gif": "./src/assets/images/SYM01.gif",
	"./SYM02.gif": "./src/assets/images/SYM02.gif",
	"./SYM03.gif": "./src/assets/images/SYM03.gif",
	"./SYM04.gif": "./src/assets/images/SYM04.gif",
	"./SYM05.gif": "./src/assets/images/SYM05.gif",
	"./SYM06.gif": "./src/assets/images/SYM06.gif",
	"./SYM07.gif": "./src/assets/images/SYM07.gif",
	"./SYM08.gif": "./src/assets/images/SYM08.gif",
	"./SYM09.gif": "./src/assets/images/SYM09.gif"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images sync recursive ^\\.\\/.*\\.gif$";